import React from 'react';
import { useWatch } from 'react-hook-form';
import WheelPreRestorationPanel from './WheelPreRestorationPanel';
import WheelSafetyInspectionPanel from './WheelSafetyInspectionPanel';
import WheelLocationDetailPanel from './WheelLocationDetailPanel';
import { getWheelInspectionFieldPath } from '../../utils/wheelInspectionUtil';

/**
 * @param {'all'|'pre'|'safety'|'location'} step
 */
const WheelInspectionSection = ({
  step = 'all',
  control,
  setValue,
  getValues,
  getFormErrorMessage,
  formRequired = false,
  fileItems,
  setFileItems,
  getFileURL,
  setLoading,
  readOnly = false,
}) => {
  const selectedPositions =
    useWatch({
      control,
      name: getWheelInspectionFieldPath('preRestoration.positions'),
    }) || [];

  const shared = {
    control,
    setValue,
    getValues,
    getFormErrorMessage,
    formRequired,
    fileItems,
    setFileItems,
    getFileURL,
    setLoading,
    readOnly,
  };

  const showPre = step === 'all' || step === 'pre';
  const showSafety = step === 'all' || step === 'safety';
  const showLocation = step === 'all' || step === 'location';

  return (
    <>
      {showPre && (
        <div className="col-12">
          <WheelPreRestorationPanel {...shared} />
        </div>
      )}
      {showSafety && (
        <div className="col-12">
          <WheelSafetyInspectionPanel
            control={control}
            setValue={setValue}
            getValues={getValues}
            readOnly={readOnly}
          />
        </div>
      )}
      {showLocation && (
        <div className="col-12">
          <WheelLocationDetailPanel
            {...shared}
            selectedPositions={selectedPositions}
          />
        </div>
      )}
    </>
  );
};

export default WheelInspectionSection;
